import TablaConciliacion from "../../../TablaConciliacion";

function TablaAutocafe() {
  return <TablaConciliacion nombreUseCase="AUTOPISTADELCAFE" titulo="AUTOPISTA DEL CAFE" />;
}

export default TablaAutocafe;
